import './typesofwebsites.css';
import React from 'react';
import TitleSection from '../TitleSection/TitleSection';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNewspaper, faPencil, faGraduationCap, faShoppingCart, faUniversity, faUsers, faFilm, faBuilding, faSearch, faHeartbeat } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const TypeItem = ({ item, index }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="col-lg-4 col-md-6"
    >
      <div className='type-item'>
        <div className='type-icon'>
          {item.icon}
        </div>
        <h4>{item.h4}</h4>
        <p>{item.p}</p>
        <a href={`https://wa.me/966568300288?text=${encodeURIComponent(`السلام عليكم، أريد خدمة ${item.h4}`)}`} target="_blank" rel="noreferrer">
          إطلب الخدمة
        </a>
      </div>
    </motion.div>
  );
};

function Typesofwebsites() {
  const data = [
    { id: 1, h4: "المواقع المؤسسية", p: "تعرض معلومات وخدمات الشركات والمؤسسات", icon: <FontAwesomeIcon icon={faBuilding} className='icon_type' /> },
    { id: 2, h4: "المواقع الإخبارية", p: "تقدم الأخبار والمعلومات العاجلة. مثل: CNN, Al Arabiya.", icon: <FontAwesomeIcon icon={faNewspaper} className='icon_type' /> },
    { id: 3, h4: "المدونات (Blogs)", p: "منصات شخصية أو مهنية لنشر المقالات والأفكار", icon: <FontAwesomeIcon icon={faPencil} className='icon_type' /> },
    { id: 4, h4: "المواقع التعليمية", p: "تقدم محتوى تعليمي ودورات تدريبية. مثل: Coursera, Khan Academy.", icon: <FontAwesomeIcon icon={faGraduationCap} className='icon_type' /> },
    { id: 5, h4: "مواقع التجارة الإلكترونية", p: "تمكن من شراء وبيع المنتجات والخدمات عبر الإنترنت. مثل: سلة, زد.", icon: <FontAwesomeIcon icon={faShoppingCart} className='icon_type' /> },
    { id: 6, h4: "المواقع الحكومية", p: "تقدم معلومات وخدمات متعلقة بالحكومة. مثل: وزارة الداخلية السعودية.", icon: <FontAwesomeIcon icon={faUniversity} className='icon_type' /> },
    { id: 7, h4: "المواقع الاجتماعية", p: "تمكن المستخدمين من التواصل والتفاعل. مثل: Facebook, منصة إكس.", icon: <FontAwesomeIcon icon={faUsers} className='icon_type' /> },
    { id: 8, h4: "المواقع الترفيهية", p: "تقدم محتوى ترفيهي مثل الألعاب والفيديوهات. مثل: YouTube, Netflix", icon: <FontAwesomeIcon icon={faFilm} className='icon_type' /> },
    { id: 9, h4: "المواقع البحثية", p: "تمكن من البحث عن المعلومات. مثل: Google, Bing.", icon: <FontAwesomeIcon icon={faSearch} className='icon_type' /> },
    { id: 10, h4: "المواقع الصحية", p: "تقدم معلومات وخدمات صحية. مثل: WebMD, Mayo Clinic", icon: <FontAwesomeIcon icon={faHeartbeat} className='icon_type' /> },
  ];

  return (
    <div className='typesofwebsites' id='typesofwebsitesid'>
      <div className="container">
        <TitleSection title="أنواع المواقع الإلكترونية" />
        <div className="row justify-content-start">
          {data.map((item, index) => (
            <TypeItem key={index} item={item} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Typesofwebsites;
